import React, { useState, useEffect } from "react";
import "../css/employee.css";
import ApiCallingService from "../../service/api-call-service";
import Can from "../../auth/can/Can";
import { Link, Redirect } from "react-router-dom";
import DashBoardImage from "../../assests/dashboard.png";
import { connect } from "react-redux";
import { store } from "../../redux/store";
import { setBand } from "../../redux/band/band.action";
import DashBoardComponent from "../component/dashboard.component";
import ResetLoginPassword from "../../corporate-profile/component/reset-login-password";
import moment from "moment";
import CategoryLimit from "../../constants/category-limit.type";
import ManageCategoryLimit from "../component/manage-category-limit.component";
import CardStatusType from "../../constants/card-status.type";
import CardStatus from "../../common/component/card-status.component";
import SmallPopUp from "../../common/component/small.popup.component";
import CardManagementService from "../../service/service-impl/CardManagementService";
import { setBackUrl, setEmployeeDetails } from "../../redux/user/user.actions";

import MangeCardUpdate from "./manageCardUpdate";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { PinDropSharp } from "@material-ui/icons";
import { setShowCardDetailSection } from "../../redux/div-show-and-hide/div-show-and-hide.action";

var currentUserT = "";
var ro_id = "";
const EmpMangeCardSection = ({
  userRole,
  roleData,
  roMdn,
  authenticated,
  isPasswordReset,
  location,
  corpBand,
  empDetail,
  currentUser,
  mdn,
  fullName,
  maxFoodAmount,
  maxGeneralAmount,
  maxTravelAmount,
}) => {
  ro_id = roMdn;
  currentUserT = currentUser;
  const [response, setResponse] = useState([]);
  const [employeeDetail, setEmployeeDetail] = useState([]);
  const [walletArray, setWalletArray] = useState([]);

  const [cardDetail, setCardDetail] = useState([]);

  const [dropDownHidden, setDropDownHidden] = useState(false);
  const [severty, setSeverty] = useState("");
  const [message, setMessage] = useState("");
  const [selectedCardType, setSelectedCardType] = useState(null);
  const [showCardSection, setshowCardSection] = useState(false);
  const [physicalKit, setPhysicalKit] = useState(null);
  const [virtualKit, setVirtualKit] = useState(null);
  const [cardStatus, setCardStatus] = useState(null);
  const [physicalCardStatusobj, setPhysicalCardStatusobj] = useState(null);
  const [newResponse, setNewResponse] = useState([]);

  useEffect(() => {
    setPhysicalKit(null);
    setVirtualKit(null);
    document.title = "ZRO Employee Mange Card";

    fetchPosts();
    fetchEmployeeDetail();
    fetchCardStatus();
  }, []);

  useEffect(() => {
    if (Array.isArray(cardDetail) && cardDetail.length !== 0) {
      cardDetail.map((val) => {
        if (val?.cardType == 0 && val?.cardStatus == 0) {
          setVirtualKit(val?.cardReferenceNo);
        } else if (val?.cardType == 1 && val?.cardStatus == 0) {
          setPhysicalKit(val?.cardReferenceNo);
        }
      });
    }
  }, [cardDetail]);

  useEffect(() => {
    if (
      physicalKit !== undefined &&
      physicalKit !== null &&
      virtualKit !== undefined &&
      virtualKit !== null &&
      cardStatus !== undefined &&
      cardStatus !== null &&
      Array.isArray(cardStatus) &&
      cardStatus.length > 0
    ) {
      const leng = cardStatus.length
      const oldObj = cardStatus[leng-1]
      
      let newObj = {
        'Ecommerce': oldObj?.ECOM,
        'POS': oldObj?.POS,
        'ATM Withdrawal': oldObj?.ATM,
        'CL': oldObj?.CL
      };
      setPhysicalCardStatusobj(newObj);
    } else if (
      physicalKit !== undefined &&
      physicalKit !== null &&
      virtualKit !== undefined &&
      virtualKit == null &&
      cardStatus !== undefined &&
      cardStatus !== null &&
      Array.isArray(cardStatus) &&
      cardStatus.length > 0
    ) {
      const oldObj = cardStatus[0]
      let newObj = {
        'Ecommerce': oldObj?.ECOM,
        'POS': oldObj?.POS,
        'ATM Withdrawal': oldObj?.ATM,
        'CL': oldObj?.CL
      };
      setPhysicalCardStatusobj(newObj);
    }
  }, [physicalKit, virtualKit, cardStatus]);

  useEffect(() => {
    if (
      physicalKit !== undefined &&
      physicalKit !== null &&
      physicalCardStatusobj !== undefined &&
      physicalCardStatusobj !== null && response !== undefined && Array.isArray(response) 
    ) {
    

      const finalArr = response.map((item)=>{
        const key = item.transactionTypeConfigLabel;
         if (physicalCardStatusobj.hasOwnProperty(key)) {
             item.cardstatus = physicalCardStatusobj[key];
          return  item
        }else{
          item.cardstatus = "D";  
          return item
        }
    })

      setNewResponse(finalArr);
    }
  }, [physicalCardStatusobj, selectedCardType, response]);
  const mobileNumber = location.state.empMobile;

  const fetchPosts = async () => {
    // const url = `${process.env.REACT_APP_GET_CARD_USAGE_MODE_BY_EMP_MDN}?customerId=8755144262/searchIndividualLimit/{customerId}/{roId}`;
    const url = `${process.env.REACT_APP_GET_CARD_USAGE_MODE_BY_EMP_MDN}?customerId=${mobileNumber}&roId=${roMdn}`;
    const headers = {
      customerId: mobileNumber,
    };

    const res = await ApiCallingService.getMethodCallWithoutParam(url, headers);

    // console.log("REACT_APP_GET_CARD_USAGE_MODE_BY_EMP_MDN", url, JSON.stringify(res));
    if (
      res !== undefined &&
      res.response !== undefined &&
      res.response.individualLimit !== undefined &&
      res.response.individualLimit !== null
    ) {
      setResponse(res.response.individualLimit);
    }
  };

  const fetchEmployeeDetail = async () => {
    // const url = `${process.env.REACT_APP_GET_Employee_Detail_By_Mdn}?ro_Id=${roMdn}&mdn=6487609904`;

    const url = `${process.env.REACT_APP_GET_Employee_Detail_By_Mdn}?ro_Id=${roMdn}&mdn=${mobileNumber}`;

    const res = await ApiCallingService.getMethodCallWithoutParam(url);

    if (
      res !== undefined &&
      res.status !== undefined &&
      parseInt(res.status) === 0 &&
      res.response !== undefined &&
      res.response.employeeDetails !== undefined
    ) {
      var detail = res.response.employeeDetails;

      var dateOfBirth = moment(detail.dob).format("YYYY-MM-DD");
      detail.dob = dateOfBirth;
      var dateOfJoining = "";
      if (
        detail.date_of_joining !== undefined &&
        detail.date_of_joining !== null
      ) {
        dateOfJoining = detail.date_of_joining.split(" ");
        detail.date_of_joining = dateOfJoining[0];
      }
      var walletDetails = res.response.employeeDetails.wallet;
      var wallet = [];
      var arrayForGeneralAmount = [];
      var arrayForTravelAmount = [];
      var arrayForFoodAmount = [];

      arrayForGeneralAmount.push(maxGeneralAmount / 100);
      arrayForTravelAmount.push(maxTravelAmount / 100);
      arrayForFoodAmount.push(maxFoodAmount / 100);

      corpBand.map((band) => {
        if (band.band === detail.band) {
          arrayForGeneralAmount.push(band.general_Limit / 100);
          arrayForTravelAmount.push(band.travel_Limit / 100);
          arrayForFoodAmount.push(band.wallet_food_limit / 100);
        }
      });
      console.log(
        " maxGeneralAmount maxTravelAmount maxFoodAmount ",
        arrayForGeneralAmount,
        arrayForTravelAmount,
        arrayForFoodAmount
      );

      walletDetails.map((limit) => {
        if (limit.wallet_id === parseInt(CategoryLimit.GENERAL)) {
          console.log("Inside maxFoodAmount");
          arrayForGeneralAmount.push(limit.amount / 100);
        }
        if (limit.wallet_id === parseInt(CategoryLimit.TRAVEL)) {
          arrayForTravelAmount.push(limit.amount / 100);
        }
        if (limit.wallet_id === parseInt(CategoryLimit.FOOD)) {
          arrayForFoodAmount.push(limit.amount / 100);
        }
      });

      arrayForGeneralAmount = arrayForGeneralAmount.filter(function (val) {
        return val !== 0;
      });
      arrayForTravelAmount = arrayForTravelAmount.filter(function (val) {
        return val !== 0;
      });
      arrayForFoodAmount = arrayForFoodAmount.filter(function (val) {
        return val !== 0;
      });

      console.log(
        " maxGeneralAmount maxTravelAmount maxFoodAmount before 0 remove",
        arrayForGeneralAmount,
        arrayForTravelAmount,
        arrayForFoodAmount
      );

      var maxGeneralAmount = Math.min(...arrayForGeneralAmount);
      var maxTravelAmount = Math.min(...arrayForTravelAmount);
      var maxFoodAmount = Math.min(...arrayForFoodAmount);

      console.log(
        " maxGeneralAmount maxTravelAmount maxFoodAmount ",
        maxFoodAmount,
        maxTravelAmount,
        maxFoodAmount
      );
      walletDetails.map((wal) => {
        var label = "label";
        var max = "max";

        if (wal.wallet_id === parseInt(CategoryLimit.GENERAL)) {
          console.log(" wallet detail GENERAL", wallet);
          wal[label] = "General";
          wal[max] = maxGeneralAmount;
          wallet.push(wal);
        }
        if (wal.wallet_id === parseInt(CategoryLimit.FOOD)) {
          console.log(" wallet detail FOOD", wallet);
          wal[label] = "Food";
          wal[max] = maxFoodAmount;
          wallet.push(wal);
        }
        if (wal.wallet_id === parseInt(CategoryLimit.TRAVEL)) {
          console.log(" wallet detail TRAVEL", wallet);
          wal[label] = "Travel";
          wal[max] = maxTravelAmount;
          wallet.push(wal);
        }
      });

      setEmployeeDetail((prevEmployeeDetail) => ({
        ...prevEmployeeDetail,
        ...detail,
      }));

      console.log("roleName", detail.roleName);

      setWalletArray(wallet);

      setCardDetail(res.response.employeeDetails.card);

      res.response.employeeDetails.card.map((ff) => {
        if (
          ff.cardType !== undefined &&
          ff.cardType !== null &&
          ff.cardType !== ""
        ) {
          setshowCardSection(true);
        }
      });

      //setRoleName(rol);
    } else {
    }

    // }
    // else {
    //     setEmployeeDetail(prevEmployeeDetail => ({ ...prevEmployeeDetail, ...null }));
    // }
  };

  const setEmployee = () => {
    store.dispatch(setEmployeeDetails(employeeDetail));
    store.dispatch(setBackUrl("/emp-list"));
  };

  const enableorDisableMode = async (event, mode) => {
    event.preventDefault();

    var id = event.target.name;

    if (selectedCardType == null) {
      setDropDownHidden(true);
      setSeverty("error");
      setMessage(
        "Please select at least one card from the list, either a physical or a virtual card"
      );
      return;
    } else if (selectedCardType == 2 && +id !== 2) {
      console.log("selectedCardType", selectedCardType, id);
      setDropDownHidden(true);
      setSeverty("error");
      setMessage(
        "Only the Ecomm card status can be updated in the case of a virtual card."
      );
      return;
    } else {
      const cardstatus = mode.cardstatus;

      const transactionFlag =
        cardstatus == "E" ? "D" : cardstatus == "D" ? "E" : null;
      const channelType =
        id == 1 ? "POS" : id == 2 ? "ECOM" : id == 3 ? "ATM" : "";
      var url = process.env.REACT_APP_ENABLE_OR_DISABLE_EMP_TXN_MODE;

      const request = {
        mobile_number: mobileNumber,
        kit_number:
          selectedCardType == 1
            ? physicalKit
            : selectedCardType == 2
            ? virtualKit
            : null,
        card_type:
          selectedCardType == 1 ? "P" : selectedCardType == 2 ? "V" : "",
        channel_type: channelType,
        transaction_flag: transactionFlag,
      };
      // console.log('request', request)
      var response = await ApiCallingService.postMethodCall(url, request);

      // console.log("enableorDisableMode response", response);

      if (
        response !== undefined &&
        response.response_code !== undefined &&
        parseInt(response.response_code) === 0
      ) {
        setDropDownHidden(true);
        setMessage(process.env.REACT_APP_MESSAGE_FOR_SUCCESSFULY_RESET_MODE);
        setSeverty("success");
        fetchPosts();
        fetchEmployeeDetail();
        fetchCardStatus();
      } else {
        setDropDownHidden(true);
        setMessage(response.response_description);
        setSeverty("error");
      }
    }
  };
  const fetchCardStatus = async () => {
    var url = process.env.REACT_APP_FETCH_CHANNEL_FLAG;
    const request = {
      mobileNumber: mobileNumber,
    };

    const response = await ApiCallingService.postMethodCall(url, request);

    // console.log("enableorDisableMode response", response);
   // console.log("response", response);
    if (      
      response !== undefined &&
      response?.code !== undefined &&
      response?.code == "00" &&
      response?.status_code == "SUCCESS"
    ) {
      setCardStatus(response?.transaction_type);
    } else {
      setDropDownHidden(true);
      setMessage(response.response_description);
      setSeverty("error");
    }
  };

  const showSwitchButton = (val) => {
    return !(val === 1 || val === 2 || val === 3);
  };

  return (
    <>
      {authenticated ? (
        <Can
          role={userRole}
          perform="empDetail-page:empMangeCard"
          roleData={roleData}
          yes={() => (
            <>
              {isPasswordReset ? (
                <div className="emp-container">
                  <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={dropDownHidden}
                    autoHideDuration={20000}
                    onClose={(e) => setDropDownHidden(false)}
                  >
                    <Alert
                      onClose={(e) => setDropDownHidden(false)}
                      severity={severty}
                    >
                      {message}
                    </Alert>
                  </Snackbar>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="head">
                          <div className="head-right">
                            <Link
                              to={{
                                pathname: "/emp-detail",
                                state: {
                                  employee: employeeDetail,
                                  editShowHidden: true,
                                },
                              }}
                              onClick={setEmployee}
                              className="back"
                            >
                              <i></i>{" "}
                            </Link>
                          </div>
                          <h3>Manage Card - {employeeDetail.fullName} </h3>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="manage-card">
                          <h3 className="subhead">Category Limit</h3>

                          <div className="row">
                            {console.log(
                              "category limit for map",
                              employeeDetail.wallet,
                              " categori label",
                              `${process.env.React_APP_MANAGECOTOGORY_LIMIT_LABEL_1}`
                            )}
                            {employeeDetail.wallet !== undefined &&
                              employeeDetail.wallet !== null &&
                              employeeDetail.wallet.map((wallet) => (
                                <ManageCategoryLimit
                                  wallet={wallet.wallet_id}
                                  employee={employeeDetail}
                                  maxFoodAmount={maxFoodAmount}
                                  maxTravelAmount={maxTravelAmount}
                                  maxGeneralAmount={maxGeneralAmount}
                                />
                              ))}
                          </div>
                        </div>
                      </div>

                      {showCardSection ? (
                        <div className="col-12">
                          <div className="manage-card">
                            <h3 className="subhead">Card Status</h3>

                            {cardDetail.map((cardDetails) => (
                              <MangeCardUpdate
                                selectedCardType={selectedCardType}
                                setSelectedCardType={setSelectedCardType}
                                cardDetails={cardDetails}
                                employeeDetail={employeeDetail}
                              />
                            ))}
                          </div>
                        </div>
                      ) : null}
                      {physicalKit !== undefined &&
                        physicalKit !== null &&
                        Array.isArray(newResponse) &&
                        newResponse.length > 0 &&
                        selectedCardType !== undefined &&
                        selectedCardType !== null &&
                        selectedCardType == 1 && (
                          <div className="col-12">
                            <div className="manage-categry">
                              <h3 className="subhead">Card Usage</h3>
                              <div className="row">
                                {newResponse.map((modeType) => (
                                  <div className="col-12 col-sm-6 col-md-3">
                                    <div className="managebox">
                                      <div className="use-control">
                                        <h6>
                                          {modeType.transactionTypeConfigLabel}
                                        </h6>
                                        {!showSwitchButton(
                                          modeType.transactionTypeConfigId
                                        ) && (
                                          <label
                                            className={
                                              modeType.cardstatus == "D" ||
                                              modeType.status === 4 ||
                                              modeType.status === 3
                                                ? "mdl-switch mdl-js-switch mdl-js-ripple-effect mdl-js-ripple-effect--ignore-events is-upgraded"
                                                : "mdl-switch mdl-js-switch mdl-js-ripple-effect mdl-js-ripple-effect--ignore-events is-checked is-upgraded"
                                            }
                                            for={
                                              modeType.transactionTypeConfigLabel
                                            }
                                            data-upgraded=",MaterialSwitch,MaterialRipple"
                                          >
                                            <input
                                              type="checkbox"
                                              id={
                                                modeType.transactionTypeConfigLabel
                                              }
                                              name={
                                                modeType.transactionTypeConfigId
                                              }
                                              className="mdl-switch__input"
                                              onChange={(e) => {
                                                enableorDisableMode(
                                                  e,
                                                  modeType
                                                );
                                              }}
                                              checked={
                                                modeType.status !== 0 &&
                                                modeType.status !== 4 &&
                                                modeType.status !== 3
                                              }
                                              disabled={
                                                modeType.status === 4 ||
                                                showSwitchButton(
                                                  modeType.transactionTypeConfigId
                                                )
                                              }
                                            />
                                            <span className="mdl-switch__label"></span>
                                            <div className="mdl-switch__track"></div>
                                            <div className="mdl-switch__thumb">
                                              <span className="mdl-switch__focus-helper"></span>
                                            </div>
                                            <span
                                              className="mdl-switch__ripple-container mdl-js-ripple-effect mdl-ripple--center"
                                              data-upgraded=",MaterialRipple"
                                            >
                                              <span className="mdl-ripple"></span>
                                            </span>
                                          </label>
                                        )}
                                      </div>

                                      {modeType.status === 4 ? (
                                        <>
                                          <div className="usedisable">
                                            {
                                              process.env
                                                .REACT_APP_VAR_FOR_Disabled_by_Corporate_Admin
                                            }
                                          </div>

                                          <div className="use-limit">
                                            <div className="progress"></div>
                                          </div>

                                          <div className="user-limit">
                                            <p className="float-left">0</p>{" "}
                                            <p className="float-right">
                                              {parseFloat(
                                                process.env
                                                  .REACT_APP_VAR_FOR_HIGHER_LIMIT_FOR_TXN_MODE_IN_RUPEE
                                              )}
                                            </p>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="use-limit">
                                            <div
                                              data-toggle="tooltip"
                                              title="Corp admin can not modify user limit"
                                              className="progress"
                                              role="tooltip"
                                            >
                                              <div
                                                className="progress-bar bg-success"
                                                role="progressbar"
                                                style={{
                                                  width: `${parseFloat(
                                                    parseFloat(
                                                      modeType.userLimit
                                                    ) /
                                                      parseFloat(
                                                        process.env
                                                          .REACT_APP_VAR_FOR_HIGHER_LIMIT_FOR_TXN_MODE_IN_RUPEE
                                                      )
                                                  )}%`,
                                                }}
                                                aria-valuenow="25"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              ></div>
                                              <div
                                                className="setamt"
                                                style={{
                                                  left: `${parseFloat(
                                                    parseFloat(
                                                      modeType.userLimit
                                                    ) /
                                                      parseFloat(
                                                        process.env
                                                          .REACT_APP_VAR_FOR_HIGHER_LIMIT_FOR_TXN_MODE_IN_RUPEE
                                                      )
                                                  )}%`,
                                                }}
                                              >
                                                {parseFloat(
                                                  parseFloat(
                                                    modeType.userLimit
                                                  ) / 100
                                                )}
                                              </div>
                                            </div>
                                          </div>

                                          <div className="user-limit">
                                            <p className="float-left">0</p>{" "}
                                            <p className="float-right">
                                              {parseFloat(
                                                process.env
                                                  .REACT_APP_VAR_FOR_HIGHER_LIMIT_FOR_TXN_MODE_IN_RUPEE
                                              )}
                                            </p>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              ) : (
                <ResetLoginPassword />
              )}
            </>
          )}
          no={() => null}
        />
      ) : (
        <Redirect to="/" />
      )}
    </>
  );
};

// const handleTempBlock = (event, data, cardDetails) => {

//     console.log("clicked ", data);

//     console.log(process.env.REACT_APP_UPDATECARDSTATUS_URL);
//     // updateCardStatus(url, mdn, useraname, otp, reason, status,header,cardReferenceNum,updateType,updatedBy ) {

//     const response = CardManagementService.updateCardStatus(process.env.REACT_APP_UPDATECARDSTATUS_URL, data.mdn, data.first_name, "", "temporary block", "3", "", cardDetails.cardReferenceNo, "temp", currentUserT, ro_id, process.env.REACT_APP_SUCESS_MESSAGE_FOR_TEMPORARY_BLOCK);

// }
// const handlePermanentBlock = (event, data, cardDetails) => {
//     console.log("clicked handlePermanentBlock", data);

//     console.log(process.env.REACT_APP_UPDATECARDSTATUS_URL);
//     CardManagementService.updateCardStatus(process.env.REACT_APP_UPDATECARDSTATUS_URL, data.mdn, data.first_name, "", "Permanent block", "4", "", cardDetails.cardReferenceNo, "permanent", currentUserT, ro_id, process.env.REACT_APP_SUCESS_MESSAGE_FOR_PERMANENT_BLOCK);

//     console.log("clicked ", data);

// }

// const handleCardUnLock = (event, data, cardDetails) => {
//     console.log("clicked handlePermanentBlock", data);
//     //store.dispatch(toggleDropDownHidden(true));

//     //store.dispatch(setMessageToBeShown('SuccessFull Permanent Block.'));
//     //url, mdn, useraname, otp, reason, status
//     console.log(process.env.REACT_APP_UPDATECARDSTATUS_URL);
//     // updateCardStatus(url, mdn, useraname, otp, reason, status,header,cardReferenceNum,updateType,updatedBy ) {

//     CardManagementService.updateCardStatus(process.env.REACT_APP_UPDATECARDSTATUS_URL, data.mdn, data.first_name, "", "Unlock Card",
//         "0", "", cardDetails.cardReferenceNo, 'unBlock', currentUserT, ro_id, 7, process.env.REACT_APP_SUCESS_MESSAGE_FOR_UNLOCK_CARD);

//     console.log("clicked ", data);
// }

const mapStateToProps = ({
  user: {
    userRole,
    roMdn,
    empDetail,
    currentUser,
    mdn,
    fullName,
    corpBand,
    maxFoodAmount,
    maxGeneralAmount,
    maxTravelAmount,
  },
  role: { roleData },
  token: { authenticated, isPasswordReset },
  band: { bandData },
}) => ({
  userRole,
  roMdn,
  roleData,
  authenticated,
  isPasswordReset,
  bandData,
  empDetail,
  currentUser,
  mdn,
  fullName,
  corpBand,
  maxFoodAmount,
  maxGeneralAmount,
  maxTravelAmount,
});

export default connect(mapStateToProps)(EmpMangeCardSection);
